export const APP_TOOLTIP_ID = 'app-tooltip';
export const APP_TOOLTIP_LIGHT_ID = 'app-tooltip-light';
export const APP_TOOLTIP_CLICK_ID = 'app-tooltip-click';
